module.exports = __webpack_public_path__ + "static/media/icon_compare_active.f16b602e.svg";